module.exports = __webpack_public_path__ + "img/bg_mounth@2x.0d9aec1f.png";